

















import * as moment from 'moment'
import Vue, { PropType } from 'vue'

import { store } from 'base/store'
import { Consumer, MesssageChannelAccess } from 'base/store/state.interface'

export default Vue.extend({
  props: {
    membersAccess: Object as PropType<{ [ucrId: string]: MesssageChannelAccess }>
  },
  computed: {
    sortedMembers(): (Consumer & MesssageChannelAccess)[] {
      return store.state.cluster.consumersorting
        .filter(ucrId => this.membersAccess[ucrId] !== undefined)
        .map(ucrId => ({ ...this.membersAccess[ucrId], ...store.state.cluster.consumer[ucrId] }))
    }
  },
  methods: {
    membersAccessStart(member: Consumer & MesssageChannelAccess) {
      if (!member.ts_create) return '—'

      const creationMoment = moment.unix(member.ts_create)
      if (creationMoment.isSame(moment(), 'day') && Math.abs(creationMoment.diff()) <= 1000 * 60 * 60) {
        return moment.duration(creationMoment.diff()).humanize()
      } else {
        return creationMoment.format('DD.MM.YYYY HH:mm')
      }
    }
  }
})
